import storage from '../../utils/storage'

const STORAGE_KEY = 'admin_surveys'
const STORAGE_RESPONSES = 'admin_survey_responses'
const STORAGE_QUESTIONS = 'admin_survey_questions'

export default {
  state: {
    surveys: [],
    responses: [],
    questions: []
  },
  mutations: {
    ADD_SURVEY(state, s) {
      state.surveys.unshift(s)
      storage.set(STORAGE_KEY, state.surveys)
    },
    DELETE_SURVEY(state, id) {
      state.surveys = state.surveys.filter(x => x.survey_id !== id)
      storage.set(STORAGE_KEY, state.surveys)
    },
    SET_SURVEYS(state, list) {
      state.surveys = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_RESPONSE(state, r) {
      state.responses.unshift(r)
      storage.set(STORAGE_RESPONSES, state.responses)
    },
    DELETE_RESPONSE(state, id) {
      state.responses = state.responses.filter(x => x.response_id !== id)
      storage.set(STORAGE_RESPONSES, state.responses)
    },
    SET_RESPONSES(state, list) {
      state.responses = list
      storage.set(STORAGE_RESPONSES, list)
    },
    SET_SURVEY_QUESTIONS(state, list) {
      state.questions = list
      storage.set(STORAGE_QUESTIONS, list)
    },
    ADD_SURVEY_QUESTION(state, q) {
      state.questions.push(q)
      storage.set(STORAGE_QUESTIONS, state.questions)
    },
    UPDATE_SURVEY_QUESTION(state, q) {
      const idx = state.questions.findIndex(x => x.question_id === q.question_id)
      if (idx >= 0) {
        state.questions.splice(idx, 1, q)
        storage.set(STORAGE_QUESTIONS, state.questions)
      }
    },
    DELETE_SURVEY_QUESTION(state, id) {
      state.questions = state.questions.filter(x => x.question_id !== id)
      storage.set(STORAGE_QUESTIONS, state.questions)
    }
  },
  getters: {
    allSurveys: state => state.surveys,
    allResponses: state => state.responses,
    allSurveyQuestions: state => state.questions
  }
}
